module.exports = __webpack_public_path__ + "static/priviliges-1-64e5ed8fabd00c0301a961eb2ec7dacb.png";